"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "DatePickerLeftIcon", {
  enumerable: true,
  get: function () {
    return _DatePickerLeftIcon.default;
  }
});
Object.defineProperty(exports, "DatePickerRightIcon", {
  enumerable: true,
  get: function () {
    return _DatePickerRightIcon.default;
  }
});
var _DatePickerLeftIcon = _interopRequireDefault(require("./Images/DatePickerLeftIcon.svg"));
var _DatePickerRightIcon = _interopRequireDefault(require("./Images/DatePickerRightIcon.svg"));